export default __webpack_public_path__ + "static/media/17 Track 17.2b2face2.mp3";